<template>
  <v-tooltip bottom>
    <v-icon v-if="isRevisadoOk()" small color="green lighten-1" slot="activator" style="font-size:25px;"
      >check_circle</v-icon
    >
    <v-icon v-if="isIncumplimiento()" small color="red lighten-1" slot="activator" style="font-size:25px;"
      >error</v-icon
    >
    <v-icon v-if="isWarning()" small color="yellow darken-3" slot="activator" style="font-size:25px;"
      >pause_circle_filled</v-icon
    >
    <span>{{ sanction }}</span>
  </v-tooltip>
</template>

<script>
import Constants from '../../../../common/constants'

export default {
  props: {
    sanction: String
  },

  methods: {
    isRevisadoOk () {
      return this.sanction === Constants.IS_FIELD_REVISADO_OK
    },
    isIncumplimiento () {
      return this.sanction === Constants.IS_FIELD_INCUMPLIMIENTO
    },
    isWarning () {
      return this.sanction === Constants.IS_FIELD_ADVERTENCIA
    }
  }
}
</script>
